import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import frLocale from './fr'
import arLocale from './ar'
import elLocale from './el'
import inLocale from './in'
import jaLocale from './ja'
import koLocale from './ko'
import msLocale from './ms'
import thLocale from './th'
import trLocale from './tr'


Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
  },
  zh: {
    ...zhLocale,
  },
  fr: {
    ...frLocale,
  },
  ar: {
    ...arLocale,
  },
  el: {
    ...elLocale,
  },
  in: {
    ...inLocale,
  },
  ja: {
    ...jaLocale,
  },
  ko: {
    ...koLocale,
  },
  ms: {
    ...msLocale,
  },
  th: {
    ...thLocale,
  },
  tr: {
    ...trLocale,
  },
}

function getLanguage() {

  console.info( 'storeage.lang:'+localStorage.getItem('locale') );
  if (localStorage && localStorage.getItem('locale')!=null) {
    return localStorage.getItem('locale');
  }
  // 使用系统语言，如果语言文件中没有则使用 en
  var lang = (navigator.language || navigator.userLanguage).split("-")[0];

  console.info(lang);
  if( localStorage.getItem('locale')==null ){
    localStorage.setItem('locale', lang);
  }
 
  return lang;
}

const _lang = getLanguage();

const i18n = new VueI18n({
  // set locale
  // options: en or zh
  locale: _lang,
  fallbackLocale: 'en',
  // set locale messages
  messages
})

console.info('nav.lang:'+navigator.language);
console.info('_lang:'+_lang);

export default i18n
